import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import ReportGateway from '~apis/report';
import UtilFunctions from '~utils/functions';
import { GoldSilverTypeEnum, MetalTypeEnum, TransactionActionEnum } from '~utils/enums';

export default function* watchGetSalesReportCardSummary(api: ReportGateway): SagaWatcherReturnType {
    yield takeEvery('report/reportGetSalesReportCardSummaryAttempt', handleGetSalesReportCardSummary, api);
}

function* handleGetSalesReportCardSummary(api: ReportGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        filters: {
            dateFrom,
            dateTo,
            branchName,
            metalType,
            silverType,
            goldType,
            transactionType,
            productId,
        }
    } = reduxState.report.salesReport.salesReportTransactionListing;

    const allBranches = reduxState.branch.allBranches;
    const branchCode = allBranches.find(branch => branch.branchName === branchName)?.branchCode;

    const response = yield* call([api, api.getSalesReportCardSummary], {
        authToken,
        action: transactionType ? UtilFunctions.Misc.getEnumValueByKey(TransactionActionEnum, transactionType) : undefined,
        productId: productId !== 0 ? productId : undefined,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        branchCode: branchCode ? branchCode : undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType.split(' ').join('')) : undefined,
        goldType: goldType ? UtilFunctions.Misc.getEnumValueByKey(GoldSilverTypeEnum, goldType.split(' ').join('')) : undefined,
        silverType: silverType ? UtilFunctions.Misc.getEnumValueByKey(GoldSilverTypeEnum, silverType.split(' ').join('')) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.reportGetSalesReportCardSummaryFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.reportGetSalesReportCardSummarySuccess(response.data));
    }
}
